import * as Business            from '../../business';
import { compose }              from 'redux';
import { connect }              from 'react-redux';
import { Fragment }             from 'react';
import { getTripAdvisorStatus } from '../business_profile_page';
import { useCallback }          from 'react';
import ConnectProfile           from './connect_profile_view';
import DisconnectProfile        from './disconnect_profile_view';
import FetchFromServer          from '../../components/fetch_from_server';
import Navbar                   from '../../components/navbar';
import React                    from 'react';


export default connect(
  (state, { businessID }) => ({
    statuses: Business.getBusinessStatuses(state, businessID),
    business: Business.getBusiness(state, businessID),
    profile:  Business.getTripAdvisorProfile(state, businessID)
  }),
  (dispatch, { businessID }) => ({
    load:              compose(dispatch, Business.loadBusiness, () => (businessID)),
    connectProfile:    compose(dispatch, Business.connectTripAdvisorProfile, id => ({ businessID, id })),
    disconnectProfile: compose(dispatch, Business.disconnectTripAdvisorProfile, () => ({ businessID }))
  })
)(TripAdvisorPage);


export function TripAdvisorPage({
  business,
  statuses,
  load,
  profile,
  connectProfile,
  disconnectProfile,
  navigateBackTo
}) {

  const status      = business && getTripAdvisorStatus(business);
  const isConnected = status === 'Connected';

  const disconnect = useCallback(() => {
    disconnectProfile();
    navigateBackTo('../');
  }, [ disconnectProfile, navigateBackTo ]);

  return (
    <Fragment>
      <Navbar title="TripAdvisor"/>
      <FetchFromServer statuses={statuses} load={load} className="settings business-profile tripAdvisor">
        {!isConnected && (
          <ConnectProfile
            name="TripAdvisor"
            connectProfile={connectProfile}
            placeholder="https://tripAdvisor.com/..."
            getProfileID={getProfileID}
          />
        )}

        {isConnected && profile && (
          <DisconnectProfile
            name="TripAdvisor"
            profileURL={`https://tripadvisor.com/${profile.id}`}
            disconnectProfile={disconnect}
          />
        )}
      </FetchFromServer>
    </Fragment>
  );
}


function getProfileID(url) {
  const urlRegex = /https:\/\/www\.tripadvisor\.com\/[A-Za-z-_]*-(g\d*-d\d*)/;
  const match    = url.match(urlRegex);
  if (match)
    return match[1];
  else
    return null;
}
